module.exports = __webpack_public_path__ + "img/9788960174115.ec9fa006.jpg";